import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { translations_en } from "./lang";

i18n.use(initReactI18next).init({
  lng: "en",
  fallbackLng: "en",
  debug: true,
  resources: {
    en: {
      translation: translations_en
    },
  },
  interpolation: {
    escapeValue: false // react already safes from xss => https://www.i18next.com/translation-function/interpolation#unescape
  }
 
});

export default i18n;
